import React, { useCallback } from "react";
import { useModal } from "../Modal";
import { ConfirmModal } from "./ConfirmModal";

export interface ConfirmOptions {
  /**
   * ダイアログのタイトル
   */
  title?: string;
  /**
   * ダイアログのメッセージ
   */
  message?: React.ReactNode;
  /**
   * キャンセルボタンのテキスト
   */
  cancelButtonText?: string;
  /**
   * 同意ボタンのテキスト
   */
  confirmButtonText?: string;
}

export const useConfirm = ({
  title: defaultTitle,
  message: defaultMessage,
  cancelButtonText: defaultCancelButtonText,
  confirmButtonText: defaultConfirmButtonText,
}: ConfirmOptions = {}) => {
  const [openModal] = useModal(ConfirmModal, { size: "sm" });
  const confirm = useCallback(
    ({
      title,
      message,
      cancelButtonText,
      confirmButtonText,
    }: {
      title?: string;
      message?: React.ReactNode;
      cancelButtonText?: string;
      confirmButtonText?: string;
    } = {}) => {
      return new Promise<boolean>((resolve) => {
        openModal({
          title: title ?? defaultTitle,
          message: message ?? defaultMessage,
          cancelButtonText:
            cancelButtonText ?? defaultCancelButtonText ?? "キャンセル",
          confirmButtonText:
            confirmButtonText ?? defaultConfirmButtonText ?? "OK",
          onCanceled: () => {
            resolve(false);
          },
          onConfirmed: () => {
            resolve(true);
          },
        });
      });
    },
    [
      defaultCancelButtonText,
      defaultConfirmButtonText,
      defaultMessage,
      defaultTitle,
      openModal,
    ],
  );
  return confirm;
};
